import { useLayoutEffect, useRef } from 'react';

import { useIsMobile } from '@sravni/react-utils';

const logoSelector = '[data-element="logo-link"]';

export const useMakeLogoNotInteractive = () => {
  const isMobile = useIsMobile();
  const headerRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (headerRef.current) {
      const logo = headerRef.current.querySelector<HTMLDivElement>(logoSelector);

      if (logo) {
        logo.style.pointerEvents = 'none';
      }
    }
  }, [isMobile]);

  return headerRef;
};
